import { InvestorDeclarationEventHandler } from '@/components/InvestorDeclarationEventHandler';
import { PostHogEventHandler } from '@/components/PostHogEventHandler';
import { WakalaFlagRelay } from '@/features/wakala/components/wakalaFlagRelay';
import { WaqfFlagRelay } from '@/features/waqf/components/waqfFlagRelay';
import { GrowthbookProvider } from '@/libs/growthbook';
import { PostHogConfig } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { PropsWithChildren } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { TanstackQueryProvider } from '../libs/tanstackQuery';

const postHogOptions: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-05-24',
};

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={postHogOptions}>
      <PostHogEventHandler />
      <InvestorDeclarationEventHandler />
      <HelmetProvider>
        <GrowthbookProvider>
          <WakalaFlagRelay />
          <WaqfFlagRelay />
          <TanstackQueryProvider>{children}</TanstackQueryProvider>
        </GrowthbookProvider>
      </HelmetProvider>
    </PostHogProvider>
  );
}
